import React, { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { addFiltersToQuery } from 'site-modules/personalized-search/utils/add-filters-to-query';
import { transformSuggestedFilters } from 'site-modules/shared/utils/inventory/semantic-search';
import { transformFacetsToUrlParams } from 'site-modules/shared/utils/inventory/srp-llm-suggested-facets';
import { getQuery } from 'client/utils/location';

const useInitialInventoryParams = componentParams => {
  const updateUrlParams = useCallback(() => {
    const query = getQuery(window.location);
    const modifiedRadius = componentParams?.modifiedFacets?.radius;

    const filters = transformFacetsToUrlParams(transformSuggestedFilters(componentParams).filters, modifiedRadius);
    addFiltersToQuery({
      pathname: window.location.pathname,
      query,
      filters,
      useReplace: true,
    });
  }, [componentParams]);

  useEffect(() => {
    if (componentParams) {
      updateUrlParams();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [componentParams]);
};

export function withInitialInventoryParamsUrlUpdate(WrappedComponent) {
  const Component = memo(({ componentParams = undefined, ...rest }) => {
    useInitialInventoryParams(componentParams);

    return <WrappedComponent {...rest} componentParams={componentParams} />;
  });

  Component.displayName = `withInitialInventoryParamsUrlUpdate(${WrappedComponent.name || WrappedComponent.displayName})`;
  Component.propTypes = {
    componentParams: PropTypes.shape({}),
  };

  return Component;
}
